'use client';

import { useEffect } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { captureSocialPublishAttributionFromUrl, removeSocialPublishTrackingParamsFromUrl } from '@/lib/social-publishing/capture';

export function SocialAttributionCapture() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams()!;

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(searchParams.toString());
    const landingPath = `${pathname}${params.toString() ? `?${params.toString()}` : ''}`;
    const captured = captureSocialPublishAttributionFromUrl(params, landingPath);
    if (!captured) return;

    const url = new URL(window.location.href);
    const nextPath = removeSocialPublishTrackingParamsFromUrl(url);
    router.replace(nextPath, { scroll: false });
  }, [pathname, router, searchParams]);

  return null;
}
